import { render, staticRenderFns } from "./SalesLineDetail.vue?vue&type=template&id=ec0955c0&scoped=true&"
import script from "./SalesLineDetail.vue?vue&type=script&lang=js&"
export * from "./SalesLineDetail.vue?vue&type=script&lang=js&"
import style0 from "./SalesLineDetail.vue?vue&type=style&index=0&id=ec0955c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0955c0",
  null
  
)

export default component.exports